import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectMicroGenres } from 'services/store/ai/selectors';
import { RootState } from 'services/store';
import { GenreSelectorProps } from '../types';
import { MicroGenre, MicroGenresContainer } from './styled';

const MicroGenreSelector = ({
  value,
  onChange,
  disabled,
}: GenreSelectorProps) => {
  const microGenre = useSelector((store: RootState) => store.ai.microGenre);
  const microGenres = useSelector(selectMicroGenres(value));

  const isSelected = useCallback(
    (name: string) => microGenre === name && !disabled,
    [microGenre, disabled]
  );

  return (
    <MicroGenresContainer>
      {microGenres.map(({ id, name }) => (
        <MicroGenre
          disabled={disabled}
          key={id}
          value={name}
          onClick={() => onChange(name)}
          selected={isSelected(name)}
        >
          {name}
        </MicroGenre>
      ))}
    </MicroGenresContainer>
  );
};

export default MicroGenreSelector;
